import { useEffect, useRef } from 'react';

const FOCUSABLE = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function useFocusTrap(isActive) {
  const ref = useRef(null);

  useEffect(() => {
    if (!isActive || !ref.current) return;

    const container = ref.current;
    const prev = document.activeElement;

    // Focus first focusable element
    const focusable = Array.from(container.querySelectorAll(FOCUSABLE));
    focusable[0]?.focus();

    const handleKeyDown = (e) => {
      if (e.key !== 'Tab') return;
      const all = Array.from(container.querySelectorAll(FOCUSABLE));
      if (!all.length) return;
      const first = all[0];
      const last  = all[all.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      prev?.focus?.();
    };
  }, [isActive]);

  return ref;
}
